import React, {Component} from 'react';
import axios from 'axios';
import {Redirect} from 'react-router';

class ActiveUser extends Component{
    constructor(props){
        super(props);

        this.state = { 
            redirectVar: null
        };


        if ( this.props.location.search ) {
            const data = {
                code : this.props.location.search
            }
            
            axios.defaults.withCredentials = true;
            
            axios.post(window.$backend_url + '/checkActivationCode',data)
                .then(response => {
                    this.setState({
                        redirectVar : <Redirect to= "/" />
                    })
                })
                .catch(error => {
                    this.setState({
                        redirectVar : <Redirect to= "/" />
                    })
                })
        }
    }
    
    componentWillMount(){
        this.setState({
            authFlag : false
        })
    }

    render(){
        return(
            <div>
                { this.state.redirectVar }
                checking your activation code.
            </div>
        )
    }
}

export default ActiveUser;


// WEBPACK FOOTER //
// ./src/components/ActiveUser.js